import { Type } from '@sinclair/typebox';
export const HomeNoteInput = Type.Object({ text: Type.String({ minLength: 1, maxLength: 500 }) }, { additionalProperties: false });
export const HomeLampInput = Type.Object({
    on: Type.Boolean(), expectedRevision: Type.Integer({ minimum: 0 }),
}, { additionalProperties: false });
//# sourceMappingURL=home.js.map